import React, { useState } from 'react'
import GenerateChallengeModal from './GenerateChallengeModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/pro-light-svg-icons'

const GenerateChallengeButton: React.FunctionComponent = () => {
	const [modalOpen, setModalOpen] = useState<boolean>(false)
	return (
		<>
			{modalOpen && (
				<GenerateChallengeModal
					isOpen={modalOpen}
					onModalClose={() => setModalOpen(false)}
				/>
			)}
			<button
				type="button"
				onClick={() => setModalOpen(true)}
				title="Generate challenge with AI"
				className="button bg-purple-800 hover:bg-purple-900 text-white glowing-button"
			>
				<FontAwesomeIcon icon={faSync} className="mr-2 text-sm" />
				Generate challenge
			</button>
		</>
	)
}

export default GenerateChallengeButton
